


























import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { format } from '@/utils/helper';
import { initPageParams } from '@/utils/constants';
import { IPageParam } from '@/store/types';
import * as ITypes from '@/store/brand-audit/apply/types';
import Modal from '@/components/dialog/Modal.vue';
import PageList from '@/components/page/Index.vue';

const Apply = namespace('brandAudit/apply');

@Component({
  components: { Modal, PageList },
})
export default class EnterpriseBrandAuthLogs extends Vue {
  @Apply.Action('queryAuditLogs') public queryLogs!: ITypes.IActions['queryAuditLogs'];
  @Apply.State('auditLogs') public logs!: ITypes.IBrandAuthLogs;

  public visible = false;

  public headers = [
    { text: '品牌编码', value: 'brandCode' },
    { text: '品牌名称', value: 'brandName' },
    { text: '申请组织编码', value: 'orgCode' },
    { text: '申请组织名称', value: 'orgName' },
    { text: '申请人', value: 'authUser' },
    { text: '审核时间', value: 'processingTime' },
    { text: '审核人', value: 'processingUser' },
    { text: '审核结果', value: 'status' },
  ];

  public statusColor(record: ITypes.IBrandAuthLogsDto) {
    return { 'red--text': record.status === 2 };
  }

  public renderProcessingTime(record: ITypes.IBrandAuthLogsDto) {
    return format(record.processingTime, true);
  }

  public onPageChange(pagination: IPageParam) {
    this.queryLogs({ ...pagination });
  }

  @Watch('visible', { immediate: true })
  public watchVisible(visible: boolean) {
    if (visible) {
      this.queryLogs({ ...initPageParams });
    }
  }
}
